module.exports = __webpack_public_path__ + "media/9.04b6cfbd.wav";